var utils = require( './utils' );

var latest_news_carousel = ( function( $ ) {

	var $carousel,
		setup = false;

	var _init = function() {
		$carousel = $( '#fp-latest-news' ).find( '.carousel' );

		_maybe_setup_slider();

		$( window ).smartresize( function() {
			_maybe_setup_slider();
		} );
	};

	var _maybe_setup_slider = function() {
		if ( utils.viewport_size().width < 992 && ! setup ) {
			_setup_carousel();
			setup = true
		}
	};

	var _setup_carousel = function() {
		$carousel.slick( {
			arrows: false,
			dots: true,
			slidesToShow: 1,
			infinite: false
		} );
	};

	if ( $( '#fp-latest-news' ).length > 0 ) {
		$( document ).ready( _init );
	}

} ) ( jQuery );

module.exports = latest_news_carousel;